/* import __COLOCATED_TEMPLATE__ from './pricing-breakdown.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
// For some reason, the specs fail without this file.
// Nolaneo – ESLint upgrade August 2022
/* eslint-disable ember/no-empty-glimmer-component-classes */
import Component from '@glimmer/component';

export default class PricingBreakdown extends Component {}
